import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 's1-card',
  templateUrl: './s1-card.component.html',
  styleUrls: ['./s1-card.component.scss']
})
export class S1Card implements OnInit {

  @Input() title: string;
  @Input() class: string | string[];
  @Input() headerStyle: string = "bg-light text-dark";
  @Input() customHeader: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
